import React from 'react';
import {ButtonBase, Tooltip, Typography} from '@material-ui/core';

const PanelChangeAdUnitLink = ({classes, unit, onOpen}) => {
  const label = unit.adName || `Ad unit ${unit.adunitId}`;

  if (!unit.adunitId) {
    return (
      <Typography variant="body2" className={classes.adUnitNameStatic} noWrap>
        {label}
      </Typography>
    );
  }

  return (
    <Tooltip title="Open this ad unit" arrow>
      <ButtonBase
        className={classes.adUnitButton}
        onClick={onOpen}
        aria-label={`Open ad unit ${label}`}
      >
        <Typography variant="body2" className={classes.adUnitName} noWrap>
          {label}
        </Typography>
      </ButtonBase>
    </Tooltip>
  );
};

export default React.memo(PanelChangeAdUnitLink);
